"use client"

import { ChevronLeft, ChevronRight } from 'lucide-react'
import Link from 'next/link'
import React from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'
import Image from 'next/image'
import { Button } from '@/components'
import { ShoppingCart } from 'lucide-react'
const products = [
    {
        id: 1,
        title: "هدست مخصوص بازی اونیکوما مدل X-P5 RGB",
        price: 2400000,
        image: "/gallery/banner6.jpg",
        endTime: new Date("2024-03-25"),
    },
    {
        id: 2,
        title: "ساعت مچی عقربه‌ای مردانه تایمکس مدل TW2V75800",
        price: 3200000,
        image: "/gallery/banner.jpg",
        endTime: new Date("2024-03-24"),
    },
    {
        id: 3,
        title: "لپ تاپ ۱۵.۶ اینچی ایسوس مدل Victus 15 FA1-9DX-15 i5 8GB",
        price: 5400000,
        image: "/gallery/banner2.jpg",
        endTime: new Date("2024-03-23"),
    },
    {
        id: 4,
        title: "گوشی موبایل سامسونگ مدل Galaxy A54 5G دو سیم کارت",
        price: 8450000,
        image: "/gallery/banner3.jpg",
        endTime: new Date("2024-03-22"),
    },
    {
        id: 5,
        title: "گوشی موبایل سامسونگ مدل Galaxy A54 5G دو سیم کارت",
        price: 8450000,
        image: "/gallery/banner4.jpg",
        endTime: new Date("2024-03-22"),
    },
    {
        id: 6,
        title: "گوشی موبایل سامسونگ مدل Galaxy A54 5G دو سیم کارت",
        price: 8450000,
        image: "/gallery/banner5.jpg",
        endTime: new Date("2024-03-22"),
    },
    {
        id: 7,
        title: "گوشی موبایل سامسونگ مدل Galaxy A54 5G دو سیم کارت",
        price: 8450000,
        image: "/gallery/5.webp",
        endTime: new Date("2024-03-22"),
    }
]
const LatestProducts = () => {
    return (
        <div className="relative">
            {/* Decorative Elements */}
            {/* <div className="absolute -top-10 -left-10 w-40 h-40 bg-primary/5 rounded-full blur-3xl" /> */}
            {/* <div className="absolute -bottom-10 -right-10 w-40 h-40 bg-primary/5 rounded-full blur-3xl" /> */}

            {/* Header Section */}
            <div className="flex items-center justify-between  px-4 mb-10 md:mb-6 relative z-10 ">
                <div className='absolute inset-x-0 top-0 mx-auto transform md:translate-y-[23px] translate-y-10 z-10 flex items-center justify-center  '>
                    <div className='bg-[#120527] h-[34px] rounded-t-full px-5 flex items-center justify-center '>
                        <h2 className="text-lg font-bold text-gray-300 bg-clip-text  bg-gradient-to-r from-primary to-primary"      >
                            محصولات جدید <span className='text-primary'>بازیتور</span>
                        </h2>
                    </div>
                </div>
                <div className="space-y-2 z-20">
                    <Link
                        href="/products"
                        className="group flex items-center gap-2 text-[#A855F7] bg-primary/10 px-4 py-2 rounded-md transition-colors"
                    >
                        <span className="text-xs font-medium">مشاهده همه</span>
                        <ChevronLeft className="w-3 h-3 text-[#A855F7]" />
                    </Link>
                </div>


                <div className="flex items-center gap-3">
                    <button className="swiper-button-next-custom p-2 rounded-md bg-card/80 border border-[#A855F7]/20 transition-all duration-300">
                        <ChevronRight className="w-3 h-3 text-[#A855F7] transition-colors" />
                    </button>
                    <button className="swiper-button-prev-custom p-2 rounded-md bg-card/80 border border-[#A855F7]/20 transition-all duration-300">
                        <ChevronLeft className="w-3 h-3 text-[#A855F7] transition-colors" />
                    </button>
                </div>

            </div>

            {/* Swiper Container */}
            <div className="relative bg-[#120527] p-6 rounded-l-3xl rounded-b-3xl ">
                <div className="absolute inset-0 bg-gradient-to-r from-[#0a0512bd] via-transparent to-[#0a0512bd] z-10 pointer-events-none" />
                <Swiper
                    modules={[Navigation]}
                    navigation={{
                        nextEl: '.swiper-button-next-custom',
                        prevEl: '.swiper-button-prev-custom',
                    }}
                    loop={true}
                    grabCursor={true}
                    autoplay={{
                        delay: 2500,
                        pauseOnMouseEnter: true
                    }}
                    breakpoints={{
                        640: {
                            slidesPerView: 2,
                            spaceBetween: 24,
                        },
                        768: {
                            slidesPerView: 3,
                            spaceBetween: 24,
                        },
                        1024: {
                            slidesPerView: 4,
                            spaceBetween: 24,
                        },
                        1280: {
                            slidesPerView: 5,
                            spaceBetween: 24,
                        },
                    }}
                    className="px-4"
                >
                    {products.map((product) => (
                        <SwiperSlide key={product.id}>
                            <div className="group relative flex flex-col overflow-hidden rounded-lg border border-border/50 bg-card">

                                <div className="relative aspect-square overflow-hidden">
                                    <Image
                                        src={product.image}
                                        alt={product.title}
                                        fill
                                        className="object-cover transition-transform duration-300 group-hover:scale-105"
                                    />
                                </div>

                                <div className="flex flex-1 flex-col text-center items-center space-y-3 p-4">
                                    <h3 className="text-xs font-medium text-foreground/90 line-clamp-2">
                                        {product.title}
                                    </h3>

                                    <div className="flex items-center justify-between">
                                        <div className="flex items-center gap-1.5">
                                            <span className="text-md font-bold text-purple-500">
                                                {product.price.toLocaleString()}
                                            </span>
                                            <span className="text-sm text-muted-foreground">تومان</span>
                                        </div>
                                    </div>


                                    <Button
                                        variant='outline'
                                        className="w-full gap-x-2 hover:bg-primary text-white"
                                        size="sm"
                                    >
                                        <ShoppingCart className="h-4 w-4" />
                                        افزودن به سبد خرید
                                    </Button>
                                </div>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </div>
    )
}

export default LatestProducts
